import axios from 'axios';

const BASE_API_URL_PRAC = `${import.meta.env.VITE_API_PROTOCOL}://${import.meta.env.VITE_PRAC_API_DOMAIN}`;

export const getDCProfessionalMappings = async () => {
    try {
        const resp = await axios.get(`${BASE_API_URL_PRAC}/public/doc-cirrus/professionals`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        console.debug('getDCProfessionalMappings: ', resp);
        return resp;
    } catch (error) {
        console.debug('getDCProfessionalMappings error is ', error);
        return new Error(error.message);
    }
};

export const getDataCurProfessionalMappings = async () => {
    try {
        const resp = await axios.get(`${BASE_API_URL_PRAC}/public/data-cur/professionals`, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        console.debug('getDataCurProfessionalMappings: ', resp);
        return resp;
    } catch (error) {
        console.debug('getDataCurProfessionalMappings error is ', error);
        return new Error(error.message);
    }
};
